interface Props {
  lines?: 2 | 3;
}

export function ListItemSkeleton({ lines = 2 }: Props) {
  return (
    <div className="flex w-full items-center gap-4 rounded-md px-4 py-1">
      <div className="flex w-full animate-pulse items-stretch">
        <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 w-16 flex-shrink-0 rounded" />
        <div
          className={`flex flex-1 flex-col gap-2 px-4 ${
            lines === 3 ? 'py-2' : 'py-3'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 h-4 w-3/5 rounded" />
            <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 h-4 w-6 rounded" />
          </div>
          {lines === 3 && (
            <div className="flex items-center gap-2">
              <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 h-3 w-16 rounded" />
              <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 h-3 w-20 rounded" />
            </div>
          )}
          <div className="flex items-center justify-between">
            <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 h-4 w-2/5 rounded" />
            {lines === 2 && (
              <div className="bg-onlight-bg-3 dark:bg-ondark-bg-3 h-4 w-12 rounded" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListItemSkeleton;
